<template>
  <div ref="decoratedField"/>
</template>

<script>
export default {
  name: 'decoratedField',
  props: {
    field: null,
    item: null
  },
  data() {
    return {
      element: {}
    }
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.reRender();
      }
    }
  },
  methods: {
    reRender() {
      if (!this.element || !this.element.$el) return;
      this.$refs.decoratedField.removeChild(this.element.$el);
      this.mountComponent();
    },
    mountComponent() {
      this.element = this.field.method(this.item, this.field.name);
      this.element.$mount();
      this.$refs.decoratedField.appendChild(this.element.$el);
    }

  },
  mounted() {
    this.mountComponent();
  }
}
</script>